export default __webpack_public_path__ + "static/media/phpcertificate.1c1385d6.jpg";